import LOCATION_FILTER_OPTIONS from '../data/location-filter-options.json';
import { uniq } from 'lodash-es';

export function isAllStatesOfCountryIncluded(
  countryName: string,
  states: string[]
) {
  const countryData = LOCATION_FILTER_OPTIONS.find(
    (item) => item.name === countryName
  );

  if (!countryData) return false;

  return countryData?.states.every((item) => states.includes(item.name));
}

export function getAllStatesOfCountry(countryName: string) {
  const countryData = LOCATION_FILTER_OPTIONS.find(
    (item) => item.name === countryName
  );

  return countryData?.states?.map((i) => i.name) ?? [];
}

export function getLocationItemByCountryName(countryName: string) {
  const countryData = LOCATION_FILTER_OPTIONS.find(
    (item) => item.name === countryName
  );

  return countryData;
}

export function getLocationContinentSyncedWithBackend(
  region?: string,
  subregion?: string
) {
  const continentNameForBackend =
    region !== 'Americas'
      ? region
      : subregion === 'South America'
      ? 'South America'
      : 'North America';

  return continentNameForBackend;
}

export function getLocationTreeOptions() {
  const continents = uniq(
    LOCATION_FILTER_OPTIONS.map((item) => item.subregion)
  );

  const econimicZones = uniq(
    LOCATION_FILTER_OPTIONS.filter((i) => !!i.zone)
      .map((i) => i.zone)
      .flat()
  );

  const dataByContinents = continents.map((continent) => {
    const countries = LOCATION_FILTER_OPTIONS.filter(
      (i) => i.subregion === continent
    );

    return {
      id: continent,
      value: continent,
      label: continent,
      doNotSetValueOnSelection: true,
      children: countries.map((item) => {
        const continentForBackend = getLocationContinentSyncedWithBackend(
          item.region,
          item.subregion
        );
        return {
          id: `${continent}::${item.name}`,
          value: `${continentForBackend}::${item.name}`,
          parentValue: continent,
          parentId: continent,
          label: item.name,
          metadata: {
            logo_url: `https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/1x1/${item.iso2.toLowerCase()}.svg`,
          },
          children: item.states.map((i) => ({
            id: `${continent}::${item.name}::${i.name}`,
            value: `${continentForBackend}::${item.name}::${i.name}`,
            parentId: `${continent}::${item.name}`,
            parentValue: `${continentForBackend}::${item.name}`,
            label: i.name,
          })),
        };
      }),
    };
  });

  const dataByEconomicZones = econimicZones.map((zone) => {
    const countries = LOCATION_FILTER_OPTIONS.filter((i) =>
      i.zone?.includes(zone)
    );

    return {
      id: zone,
      value: zone,
      label: zone,
      doNotSetValueOnSelection: true,
      children: countries.map((item) => {
        const continentForBackend = getLocationContinentSyncedWithBackend(
          item.region,
          item.subregion
        );
        return {
          id: `${zone}::${item.name}`,
          value: `${continentForBackend}::${item.name}`,
          parentId: zone,
          parentValue: zone,
          label: item.name,
          metadata: {
            logo_url: `https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/1x1/${item.iso2.toLowerCase()}.svg`,
          },
          children: item.states.map((i) => ({
            id: `${zone}::${item.name}::${i.name}`,
            value: `${continentForBackend}::${item.name}::${i.name}`,
            parentId: `${zone}::${item.name}`,
            parentValue: `${continentForBackend}::${item.name}`,
            label: i.name,
          })),
        };
      }),
    };
  });

  return [dataByContinents, dataByEconomicZones];
}
